import React from 'react';
import { Link } from 'react-router-dom';
import DashboardSidebar from '../components/DashboardSidebar';
import TherapistSlotManager from '../components/TherapistSlotManager';

const AvailabilityPage = () => {
  return (
    <>
      <DashboardSidebar userRole="physiotherapist" />
      <div style={{ minHeight: '100vh', background: '#f8f9fa', padding: '40px 20px', marginLeft: '280px' }}>
        <div style={{ maxWidth: '950px', margin: '0 auto' }}>
          {/* Header */}
          <div style={{ marginBottom: '24px' }}>
            <Link to="/physio-dashboard" style={{ color: '#6366f1', textDecoration: 'none', marginBottom: '16px', display: 'inline-block', fontWeight: 600 }}>
              ← Back to Therapist Dashboard
            </Link>
            <h1 style={{ fontSize: '28px', fontWeight: 800, color: '#0f172a', margin: '0 0 8px 0' }}>
              🗓️ Manage Session Availability & Time Slots
            </h1>
            <p style={{ color: '#64748b', margin: 0, fontSize: '14px' }}>
              Create and manage your available consultation slots. These time slots will appear live on your therapist profile for clients to book.
            </p>
          </div>

          <TherapistSlotManager />
        </div>
      </div>
    </>
  );
};

export default AvailabilityPage;
